<template>
  <component
    :is="layout"
    v-if="layout"
  >
    <router-view />
  </component>
</template>

<script lang="ts">
import {defineComponent} from 'vue'
import {SplashScreen} from "@capacitor/splash-screen"
import {Keyboard} from "@capacitor/keyboard"
import {SafeArea, type SafeAreaInsets} from "capacitor-plugin-safe-area"
import {installKeyboardScroll} from "@/utils/keyboardScroll"

export default defineComponent({
  data() {
    return {
      keyboardHeight: 0
    }
  },
  head() {
    return {
      titleTemplate: "%s | " + import.meta.env.VITE_APP_NAME,
      title: this.$route?.meta?.title || this.$route?.name || undefined
    }
  },
  computed: {
    layout(): string | null {
      if (!this.$route) return null
      return this.$route.meta?.layout ? this.$route.meta.layout + "Layout" : "EmptyLayout"
    }
  },
  watch: {
    keyboardHeight: {
      handler(newHeight: string) {
        document.documentElement.style.setProperty('--keyboard-height', newHeight + 'px')
      },
      immediate: true
    }
  },
  beforeUnmount(): any {
    if (this.$capacitor.isNativeApp()) {
      Keyboard.removeAllListeners()
    }
    document.documentElement.style.removeProperty('--keyboard-height')
  },
  async mounted() {
    if (this.$capacitor.isNativeApp()) {
      await SplashScreen.hide()
      installKeyboardScroll()
      SafeArea.getSafeAreaInsets().then(({insets}: SafeAreaInsets) => {
        console.info('Received Safe Area Insets:', JSON.stringify(insets))
        for (const [key, value] of Object.entries(insets)) {
          document.documentElement.style.setProperty(
            `--safe-area-inset-${key}`,
            `${value}px`,
          )
        }
      })
      SafeArea.addListener('safeAreaChanged', ({insets}: SafeAreaInsets) => {
        console.info('Safe Area Insets Changed:', JSON.stringify(insets))
        for (const [key, value] of Object.entries(insets)) {
          document.documentElement.style.setProperty(
            `--safe-area-inset-${key}`,
            `${value}px`,
          )
        }
      }).then()
      await Keyboard.addListener('keyboardWillShow', (info) => {
        this.keyboardHeight = info.keyboardHeight
      })
      await Keyboard.addListener('keyboardWillHide', () => {
        this.keyboardHeight = 0
      })
    }
  }
})
</script>

<style>
</style>
